import HistoryAssemblyMaterial from './HistoryAssemblyMaterial';

export default HistoryAssemblyMaterial;